import { memo } from 'react';

import cn from 'classnames';

import { OButton, OModal } from '@src/shared';

import useSaveAndShareModal from './useSaveAndShareModal';

import { ISaveAndShareModalProps } from './saveAndShare.types';

import styles from './saveAndShareModal.module.scss';

const SaveAndShareModal = (props: ISaveAndShareModalProps) => {
  const {
    isCapturing,
    previewImage,
    isSaveModalOpen,
    previewContainerRef,

    handleSaveLocal,
    handleSaveAndShare,
    setSaveModalState,

    saveModalTriggerSource,
    handleStopAnnotating,
  } = useSaveAndShareModal(props);

  // Determine if we're in confirmation mode (triggered from popper)
  const isConfirmationMode = saveModalTriggerSource === 'popper';

  return (
    <OModal
      isOpen={isSaveModalOpen}
      onClose={() => setSaveModalState({ isSaveModalOpen: false })}
      title={isConfirmationMode ? 'Hide Annotations' : 'Save presented screen'}
      classes={{
        container: cn(styles.modalContainer, { [styles.confirmationModalContainer]: isConfirmationMode }),
        body: styles.modalBody,
        header: styles.modalHeader,
        title: styles.modalTitle,
        modal: styles.modal,
      }}
      hasBackdrop
    >
      <div className={cn(styles.modalContent, { [styles.confirmationModeContent]: isConfirmationMode })}>
        {isConfirmationMode ? (
          <div className={styles.hideAnnotations}>Do you want to save your current annotations before hiding them?</div>
        ) : (
          <div className={styles.previewContainer} ref={previewContainerRef}>
            {isCapturing ? (
              <div className={styles.loading}>Capturing screenshot...</div>
            ) : previewImage ? (
              <img src={previewImage} alt="Screenshot preview" className={styles.previewImage} />
            ) : (
              <div className={styles.noPreview}>Unable to capture screenshot</div>
            )}
          </div>
        )}

        <div className={cn(styles.buttonContainer, { [styles.confirmationButtonContainer]: isConfirmationMode })}>
          <OButton
            text="Save & Share on Chat"
            outlined
            variant={isConfirmationMode ? 'none' : 'secondary'}
            size="auto"
            onClick={handleSaveAndShare}
            disabled={!previewImage || isCapturing}
            classes={{ container: cn({ [styles.saveAndShareButton]: isConfirmationMode }) }}
          />
          {isConfirmationMode && (
            <OButton text="Hide" outlined variant="secondary" size="auto" onClick={handleStopAnnotating} />
          )}
          <OButton
            text={isConfirmationMode ? 'Save' : 'Save Local'}
            variant="primary"
            size="auto"
            onClick={handleSaveLocal}
            disabled={!previewImage || isCapturing}
          />
        </div>
      </div>
    </OModal>
  );
};

export default memo(SaveAndShareModal);
